export default "__VITE_ASSET__Cma9I2zI__"